import React, { useState } from 'react'
import { TextField } from '@nike/eds'

import { parseJwt } from './oAuth.js'
import ParseToken from './ParseToken.js'

export default function TokenInspector({ claims }) {
  let [token, setToken] = useState('')
  const parsedToken = token && parseJwt(token)

  let error = token && parsedToken.error && 'Invalid Token'

  return (
    <div>
      {!claims && (
        <TextField
          value={token}
          onChange={e => setToken(e.target.value)}
          hasErrors={!!error}
          errorMessage={error}
        />
      )}

      {token && parsedToken && (
        <div>
          <ParseToken token={parsedToken.header} title={'Header'} />
          <ParseToken token={parsedToken.payload} title={'Payload'} />
        </div>
      )}

      {claims && (
        <div>
          <ParseToken token={claims.accessClaims} title={'Access Token'} />
          <ParseToken token={claims.openIdClaims} title={'Open ID Token'} />
        </div>
      )}
    </div>
  )
}
